import { render, staticRenderFns } from "./SelectTamplate.vue?vue&type=template&id=2c569ccc"
import script from "./SelectTamplate.vue?vue&type=script&lang=js"
export * from "./SelectTamplate.vue?vue&type=script&lang=js"
import style0 from "./SelectTamplate.vue?vue&type=style&index=0&id=2c569ccc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports